<template>
  <div class="mt-3">
    <template v-if="!notaFiscal.fornecedor">
      <div class="text-center grey--text text--darken-1 my-5">
        Não é possível vincular esta nota, pois o fornecedor não está cadastrado.
      </div>
    </template>
    <template v-else>
      <div class="mt-3 mb-3">
        Selecione abaixo a ordem de compra que deseja vincular a esta nota fiscal
        ({{ notaFiscal.chaveAcesso }}).
      </div>
      <px-search-text class="rounded-tag-small"
                      label="Busque por um número de OC"
                      v-model="searchText"
                      :on-search="onSearch"/>
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && !compras.content.length">
        <div class="text-center grey--text text--darken-1 my-5">
          Nenhuma ordem de compra encontrada
        </div>
      </div>
      <div v-if="!loading && compras.content.length">
        <v-radio-group v-model="localValue">
          <v-row dense no-gutters class="text--primary caption">
            <v-col cols="12" sm="4" class="ml-3">
              Código
            </v-col>
            <v-col cols="12" sm="3">
              Faturamento
            </v-col>
            <v-col cols="12" sm="3">
              Total
            </v-col>
            <v-col cols="12" sm="2">
            </v-col>
          </v-row>
          <v-radio
            v-for="compra in compras.content"
            :key="compra.id"
            :value="compra"
            class="mr-3"
          >
            <template v-slot:label="">
              <v-row dense no-gutters class="text--primary pt-4">
                <v-col cols="12" sm="4">
                  {{ codigoCompra(compra) }}
                </v-col>
                <v-col cols="12" sm="3">
                  {{ compra.dataFaturamento | date }}
                </v-col>
                <v-col cols="12" sm="3">
                  {{ compra.total | currency }}
                </v-col>
                <v-col cols="12" sm="2" class="">
                  <px-compra-detalhes-dialog-view :compra-id="compra.id"/>
                </v-col>
              </v-row>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
    </template>
  </div>
</template>

<script>
import CompraService from '@/modules/compra/compra-service';
import CompraDetalhesDialogView from '@/modules/compra/detalhes/CompraDetalhesDialogView.vue';
import { hasAnyLetter, onlyNumbers } from '@/utils/regex-utils';

const DEFAULT_LIMIT = 10;

export default {
  props: {
    value: Object,
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      searchText: null,
      loading: false,
      compras: {
        total: 0,
        content: [],
      },
    };
  },
  computed: {
    codigoCompra() {
      return compra => (compra.codigoInterno ? `${compra.codigoInterno} / ${compra.id}` : compra.id);
    },
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    getComprasLinkadas() {
      return this.notaFiscal.notaFiscalCompraLinks
        ? this.notaFiscal.notaFiscalCompraLinks.map(link => link.compra.id) : [];
    },
    buildFilter() {
      const filters = [
        `fornecedor.id = ${this.notaFiscal.fornecedor.id}`,
        `comprador.id = ${this.notaFiscal.comprador.id}`,
        '(situacao != \'CANCELADA\' and situacao != \'RECUSADA\')',
        '(situacaoEntrega != \'ENTREGUE\')',
      ];
      if (this.searchText) {
        const searchText = this.searchText.toLowerCase();
        const idFilter = !hasAnyLetter(this.searchText) ? ` or id = ${onlyNumbers(this.searchText)}` : '';
        filters.push(`(codigoInterno like '%${searchText}%' ${idFilter})`);
      }

      const comprasLinkadas = this.getComprasLinkadas();
      if (comprasLinkadas.length) {
        filters.push(`id not in (${comprasLinkadas.join(',')})`);
      }

      return `${filters.join(' and ')} order by dataCompra desc`;
    },
    onSearch() {
      this.getCompras();
    },
    getCompras() {
      if (!this.notaFiscal.fornecedor) {
        return Promise.resolve();
      }
      this.loading = true;
      return CompraService.getCompras({
        limit: DEFAULT_LIMIT,
        offset: 0,
        query: this.buildFilter(),
      })
        .then((response) => {
          this.compras = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCompras();
  },
  components: {
    pxCompraDetalhesDialogView: CompraDetalhesDialogView,
  },
};
</script>
